import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { AuthShell, field, label, primaryBtn } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch { setSent(true); }
    finally { setLoading(false); }
  };
  return (
    <AuthShell title="Recupera password" subtitle="Ti invieremo un link per reimpostarla">
      {sent ? (
        <div className="space-y-4">
          <p className="text-sm">Se l'email è registrata, riceverai a breve un link di reset. Controlla la tua casella.</p>
          <Link to="/login" className="text-primary font-medium hover:underline text-sm">Torna all'accesso</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><label className={label}>Email</label><input className={field} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" /></div>
          <button className={primaryBtn} disabled={loading} data-testid="forgot-submit-button">{loading ? "Invio..." : "Invia link"}</button>
          <Link to="/login" className="block text-center text-sm text-primary hover:underline">Torna all'accesso</Link>
        </form>
      )}
    </AuthShell>
  );
}
